<div class="room-settings__wrapper">
  <h3>{{ '+INSTALLATIONS.INSTALLATION.REFERENCE_ROOM.MANAGE_ROOM.HEADER' | translate }}</h3>

  <p class="mt-[16px] mb-[8px]">
    {{ '+INSTALLATIONS.INSTALLATION.REFERENCE_ROOM.MANAGE_ROOM.DESCRIPTION' | translate }}
  </p>

  <div class="active-room-list" *ngIf="(rrsService.roomsAssignedToChannel$ | async)?.length > 0">
    <p
      class="subtext"
      *ngIf="(rrsService.roomsAssignedToChannel$ | async)?.length > 0"
    >
      {{ '+INSTALLATIONS.INSTALLATION.REFERENCE_ROOM.MANAGE_ROOM.SUBTEXT' | translate }}
    </p>

    <div
      *ngFor="let room of rrsService.roomsAssignedToChannel$ | async"
      class="room"
      (click)="goToRoomDetails(room.properties.name.value)"
    >
      <div class="flex items-center gap-[8px]">
        <span class="room-name">
          {{ room | value2: FeaturePropertyKey.name }}
        </span>
      </div>

      <mat-icon class="cursor-pointer">arrow_forward_ios</mat-icon>
    </div>
  </div>
</div>

<p
  *ngIf="!(channelEntity$ | async).feature.properties.roomInfluenceEnabled.value"
  class="mt-[24px] pl-[8px] flex"
>
  <mat-icon class="mr-[8px]">info_outline</mat-icon>
  {{ '+INSTALLATIONS.INSTALLATION.REFERENCE_ROOM.MANAGE_ROOM.WARNING' | translate }}
</p>

<div class="w-full flex justify-center">
  <button
    class="mt-[24px]"
    mat-stroked-button
    gtm="onSelect"
    gtmAction="Go to reference room assignment"
    gtmCategory="installationDetails"
    (click)="goToRoomAssignment()"
  >
    {{ '+INSTALLATIONS.INSTALLATION.REFERENCE_ROOM.MANAGE_ROOM.MANAGE_BTN' | translate }}
  </button>
</div>
